import { render, staticRenderFns } from "./AboutSettings.vue?vue&type=template&id=47e02fef&scoped=true&"
import script from "./AboutSettings.vue?vue&type=script&lang=js&"
export * from "./AboutSettings.vue?vue&type=script&lang=js&"
import style0 from "./AboutSettings.vue?vue&type=style&index=0&id=47e02fef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e02fef",
  null
  
)

export default component.exports